import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("{{! RESPONSIBLE TEAM: team-growth-opportunities }}\n{{yield}}",{ moduleName: "embercom/components/start/body-component.hbs" })